import Pagination from "../../components/Pagination";
import IconCog from "./../../layout/left_menu_icons/icon_menu_settings_default.svg";
import { ReactComponent as IconActive } from "../../layout/icons_status/icon_status_active.svg";
import { ReactComponent as IconInactive } from "../../layout/icons_status/icon_status_inactive.svg";
import IconEdit from "../../layout/others/icon_edit.svg";
import { useUserContext } from "./UserContext";
import SortedHeader from "../../components/Tables/SortedHeader";
import { useTranslation } from "react-i18next";
import "../styles/header.scss";
import "../styles/tables.scss";
import { useEffect, useState } from "react";
import { useGeneralContext } from "../General/Context";
import { UserService } from "../../services/UserService";
import { translateAndSortAscendant } from "../../common/helper";

const UserList = () => {
  const {
    users,
    isUserListLoading,
    openForm,
    onOpenCreateUserForm,
    pageNumber,
    getUsers,
    totalPages,
    setPageNumber,
    searchObject, 
    setSearchObject,
    roles
  } = useUserContext();
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const [userList, setUserList] = useState([]);
  const [headers, setHeaders] = useState([
    { label: t("Name"), field: "UserName" },
    { label: t("Email Address"), field: "Email" },
    { label: t("Status"), field: "Active" },
    { label: t("Role"), field: "UserRoles" },
    { label: t("Report to"), field: "Supervisor" },
    { label: "" }
  ]);

  useEffect(() => {
    if (pageNumber !== 1) setPageNumber(1);
    else {
      getUsers();
    }
  }, [searchObject]);

  useEffect(() => {
    UserService.getAllSupervisors().then((data) => 
      setUserList(translateAndSortAscendant (data, "nickName")));
  }, []);

  function onChangeSearch({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  const clearFilters = () => {
    setSearchObject({});
  };

  return (
    <div>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={IconCog} alt="ni-icon" />
            <h1>{t("User Management")}</h1>
          </div>
          <div className="subtitle">{t("Settings / Users")}</div>
        </div>
        {userInformation.permissions.User_Management_Add_Edit && (
          <div>
            <div className="text-end col-auto">
              <button
                onClick={onOpenCreateUserForm}
                className="app-button btn-prime btn-md"
              >
                {t("+ Add user")}
              </button>
            </div>
          </div>
        )}
      </header>
      <div className="col mt-2">
        <ul className="list-inline">
          <li className="list-inline-item">
            <div className="form-group">
              <input
                type="text"
                placeholder={t("Name, Mail or Phone number...")}
                name="nameOrEmail"
                onChange={onChangeSearch}
                value={searchObject.nameOrEmail || ""}
                style={{ width: "270px" }}
              />
            </div>
          </li>
          <li className="list-inline-item">
            <div className="form-group">
              <select
                className="form-select"
                onChange={onChangeSearch}
                name="status"
                value={searchObject.status || ""}
                required
                title={t("Selecione um item da lista.")}
                style={{ width: "200px" }}
              >
                <option value="">{t("Status...")}</option>
                <option value={true}>{t("Active")}</option>
                <option value={false}>{t("Inactive")}</option>
              </select>
            </div>
          </li>
          <li className="list-inline-item">
            <div className="form-group">
              <select
                onChange={onChangeSearch}
                name="roleId"
                required
                value={searchObject.roleId || 0}
                title={t("Selecione um item da lista.")}
              >
                <option key={0} value="" selected>
                  {t("Roles...")}
                </option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {t(role.description)}
                  </option>
                ))}
              </select>
            </div>
          </li>
          <li className="list-inline-item">
            <div className="form-group">
              <select
                onChange={onChangeSearch}
                name="ReportToId"
                required
                title={t("Selecione um item da lista.")}
                value={searchObject.ReportToId || 0}
              >
                <option key={0} value="" selected>
                  {t("Report to...")}
                </option>
                {userList.map((userList) => (
                  <option key={userList.id} value={userList.id}>
                    {t(userList.nickName)}
                  </option>
                ))}
              </select>
            </div>
          </li>
          <li className="list-inline-item">
            <div className="form-group">
              <button
                type="button"
                onClick={() => clearFilters()}
                className="app-button btn-second btn-md"
              >
                {t("Clear")}
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div className="table-wrap users-list">
        {isUserListLoading ? (
          <>
            <table>
              <thead>
                <SortedHeader
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  headers={headers}
                  setHeaders={setHeaders}
                />
              </thead>
            </table>
          </>
        ) : (
          <>
            <table>
              <thead>
                <SortedHeader
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  headers={headers}
                  setHeaders={setHeaders}
                />
              </thead>
              <tbody>
                {users.map((_user) => {
                  return (
                    <tr key={_user.id}>
                      <td title={_user.userName} className="name text-truncate">
                        {_user.userName}
                      </td>
                      <td title={_user.email} className="email text-truncate">
                        {_user.email}
                      </td>
                      <td
                        title={_user.active ? t("Active") : t("Inactive")}
                        className="status text-truncate"
                      >
                        {_user.active ? <IconActive /> : <IconInactive />}
                        {_user.active ? t("  Active") : t(" Inactive")}
                      </td>
                      <td
                        title={t(_user.roles[0]?.description)}
                        className="role text-truncate"
                      >
                        {t(_user.roles[0]?.description)}
                      </td>
                      <td className="report text-truncate">{_user.supervisor}</td>
                      <td>
                        {userInformation.permissions
                          .User_Management_Add_Edit && (
                          <button
                            onClick={() => openForm(_user.id)}
                            className="action-button-settings"
                            type="button"
                          >
                            <img
                              src={IconEdit}
                              alt="edit"
                              width="12px"
                              height="auto"
                            />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {users.length === 0 && (
              <div className="loader-wrapper">{t("No users found.")}</div>
            )}
          </>
        )}
      </div>
      <div className="row">
        <div className="offSset">
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      </div>
    </div>
  );
};

export default UserList;
